import React ,{useState,useMemo} from 'react'
import { useSelector,useDispatch } from 'react-redux'
import { login } from '../Redux/Login/LoginActions';

import {
  Form,
  Navbar,
  Nav,
  Button
} from "react-bootstrap";
import { config } from '../Redux/config';
function Login(){
  // store data access start
const loginData = useSelector(state =>state.Login);


// store data access End
  const dispatch = useDispatch()  // for accessing the redux function

  // component all states define start
  const [inputValue,setInputValue] = useState({email:'',password : ''})

    const [error,setError] = useState(null)
    const [successStatus,setSuccessStatus] = useState(null)
    const [passwordHide,setPasswordHide] = useState(true)
  // component all states define End

   //hooks start

// add data of login api into constant,hook start
   useMemo(()=>{
     if(loginData && loginData.login && loginData.login.request_status === false){
       setError(loginData.login.object.error)
     }
   },[loginData])
// add data of login api into constant,hook End

// add data of login api into constant,hook start
   useMemo(()=>{
     if(loginData && loginData.login && loginData.login.request_status === true){
        setSuccessStatus(loginData.login.object.status)
        localStorage.setItem('access_token', loginData.login.object.access_token);
        localStorage.setItem('user_email', inputValue.email);
        localStorage.setItem('mid', loginData.login.object.mid);
        window.location.href = '/';
     }
   },[loginData])
// add data of login api into constant,hook End
   //hooks end

// component function start

// examHandler function start
  const loginHandler = (event) =>{
    event.preventDefault()
    const login_info = inputValue;
    dispatch(login(login_info))
 }
// examHandler function End
 const loadCall = () =>{

  if(localStorage.getItem('new_token')) {
    localStorage.removeItem('new_token');
   
  }
  if(localStorage.getItem('device_token')) {
    localStorage.removeItem('device_token');
 
  }
  
 }

if(loginData && loginData.login && loginData.login.object && loginData.login.object.status == true){
  localStorage.setItem('access_token', loginData.login.object.access_token);
  localStorage.setItem('user_email', inputValue.email);
  localStorage.setItem('mid', loginData.login.object.mid);
      window.location.href = '/';
    }
  return(
  <>
  {loadCall()}
 
  <div className="login-header">
      <Navbar bg="orange" variant="dark">
        <Navbar.Brand href="#home">
          <img
              src="img/logo.png"
              width="192px"
              height="57px"
              className="d-inline-block align-top"
              alt="React Bootstrap logo"
            />
        </Navbar.Brand>
        <Nav className="mr-auto">
        </Nav>
        <Form inline>
          <Nav.Link href="/login">Login</Nav.Link>
        </Form>
      </Navbar>
  </div>
  <div className="Below-header">
  <div className='row adminLogin'>
              <div className='col-md-4'>
              </div>
              <div className='col-md-4'>
                  <div className='login-page' />
                  <div className="Login">
                    {error != null ? (<h6 className="addStudent-error">*{JSON.stringify(error).replace(/[\[\]"]+/g,"")}</h6>):null  }
                      <Form onSubmit={(e) => loginHandler(e)}>
                          <Form.Group controlId="email">
                           <Form.Label> Email address </Form.Label>
                              <Form.Control
                                  autoFocus
                                  type="email"
                                  value={inputValue.email}
                                  onChange={(e) =>setInputValue({...inputValue,email:e.target.value})}
                              />
                              {error != null && error.email ? (<h6 className="addStudent-error">*{JSON.stringify(error.email).replace(/[\[\]"]+/g,"")}</h6>):null}
                          </Form.Group>
                          <Form.Group controlId="password" className="login-password">
                          <Form.Label> Password </Form.Label>
                              <Form.Control
                                  value={inputValue.password}
                                  onChange={(e) =>setInputValue({...inputValue,password:e.target.value})}
                                  type={passwordHide ? "password" : "text"}
                              />
                              {passwordHide ? (
                              <i className="far fa-eye eye-password-icon"  onClick={() =>setPasswordHide(!passwordHide)}></i>
                            ) : (
                              <i className="fa fa-eye-slash eye-password-icon" aria-hidden="true" onClick={() =>setPasswordHide(!passwordHide)}></i>
                            )}
                            {error != null && error.password ? (<h6 className="addStudent-error">*{JSON.stringify(error.password).replace(/[\[\]"]+/g,"")}</h6>):null}
                          </Form.Group>
                          <Button
                              block
                              type="submit"
                          >
                              Login
                          </Button>
                      </Form>
                      <h6 className="right-float"><a href={`${config.api_account}/user/password/forget`}>forget password</a></h6>
                  </div>
              </div>
              <div className='col-md-4'>
              </div>
          </div>
     </div>
  </>
  )
}

export default Login
